import { createContext, useContext } from 'react';

import type { DeviceContext, UseDevice } from './types';

const deviceContextDefault: DeviceContext = {
    deviceOS: 'other',
    deviceType: 'mobile',
    networkStatus: 'online'
};

const context = createContext(deviceContextDefault);

const useDevice: UseDevice = () => {
    const devices = useContext(context);

    if (typeof devices === 'undefined') {
        throw new Error('No DeviceProvider found');
    }

    return {
        context,
        devices
    };
};

export default useDevice;
